export * from '@cipafacil/version/public-api';
